import React from 'react'

const InsightLayoutRow = (props) => {
    const { viewData } = props;

    return (
        <>
            <span className="uiMenuItemLabel">{viewData.dataList.ln}</span>
        </>
    )
}

export default InsightLayoutRow